import React from "react";
import {Typography} from "@material-ui/core";
import EditorTool from "../../../../components/EditorTool";
import {
	KHMER_TEXT_BYTE_LIMIT,
	byteLength,
	isRichTextEmpty,
	plainTextLength,
} from "../utils/khmerText";

/**
 * Khmer counterpart of a product rich-text field, rendered directly under its
 * English input so an untranslated field is obvious at a glance.
 *
 * Blank is a valid state — nothing is ever pre-filled from the English value.
 */
function KhmerRichTextField({label, value, onChange, error}) {
	const bytes = byteLength(value || "");
	const characters = plainTextLength(value);
	const overLimit = bytes > KHMER_TEXT_BYTE_LIMIT;
	const empty = isRichTextEmpty(value);

	return (
		<>
			<Typography variant="subtitle1">{label}</Typography>
			<EditorTool value={value} setValue={onChange} page="products"/>
			<Typography
				variant="caption"
				component="div"
				style={{
					marginTop: 4,
					color: error || overLimit ? "#d32f2f" : "rgba(0, 0, 0, 0.54)",
				}}
			>
				{error
					? error
					: empty
						? "Not translated yet — leave blank until a Khmer translation is ready."
						: `${characters.toLocaleString()} characters · ${bytes.toLocaleString()} of ${KHMER_TEXT_BYTE_LIMIT.toLocaleString()} bytes`}
			</Typography>
		</>
	);
}

export default KhmerRichTextField;
